import React, { useContext, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import VerificationInput from "react-verification-input";
import { ThemeContext } from "../context/ThemeContext";

const OtpModal = ({
  showOtp,
  handleClose,
  onChange,
  onClose,
  onVerify,
  error = null,
  verificationCode,
  setVerificationCode,
  loading,
  phone,
  email,
}) => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const handleVerificationChange = (value) => {
    setVerificationCode(value);
    if (onChange) {
      onChange(value);
    }
  };

  const handleVerify = () => {
    if (onVerify) {
      onVerify(verificationCode);
    }
  };

  const handleCancel = () => {
    setVerificationCode(""); // Clear the code when canceling
    if (onClose) {
      onClose();
    }
    if (handleClose) {
      handleClose();
    }
  };

  return (
    <div className="otp_div ">
      <Modal
        show={showOtp}
        // onHide={}
        backdrop="static"
        keyboard={false}
        // className={theme ? "food-modal" : ""}
        style={{
          minHeight: "150px",
          height: "auto",
          marginTop: "150px",
        }}
        className={`${theme ? "food-modal" : ""}`}
      >
        <Modal.Body
          style={{
            padding: "20px",
            height: "auto",
          }}
          className="modal-content"
        >
          <div className="otp_div">
            <h5
              style={{
                color: theme ? "white" : "var(--color)",
              }}
            >
              {t("OTP Verification")}
            </h5>
            <p
              style={{
                color: theme ? "white" : "black",
              }}
            >
              {t("Please enter the OTP sent to your")}
              {email !== "" ? ` email (${email}) and ` : " "}
              {t("phone number")} ({phone}){" "}
              {t("to complete the verification process. Thank you!")}
            </p>
            <VerificationInput
              value={verificationCode}
              // onChange={(e) => setVerification_code(e)}
              validChars="0-9"
              inputProps={{}}
              inputField={{
                inputMode: "numeric",
                onChange: (e) => {
                  if (e.nativeEvent.target.value) {
                    onChange(e.nativeEvent.target.value);
                  }
                  //  setOtp(e.nativeEvent.target.value);
                },
              }}
            />

            {error && (
              <div className="mt-2">
                <span className="text-danger">{error}</span>
              </div>
            )}

            <div className="butons_opt mt-3">
              <Button
                className="canc reg-btn order-btn me-2"
                onClick={handleCancel}
                variant="secondary"
              >
                {t("Cancel")}
              </Button>
              <Button
                className="reg-btn order-btn"
                onClick={handleVerify}
                disabled={verificationCode?.length !== 6 || loading}
                variant="primary"
              >
                {t("Verify")}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OtpModal;
